import React from "react";
import styled from "styled-components";
import dayjs from "dayjs";

import * as u from "../utils";
import * as T from "./Typography";

Input.defaultProps = {
  hint: "Placeholder",
};

export default function Input(props) {
  const inputRef = React.useRef(null);
  const onClick = () => {
    inputRef.current.focus();
  };
  const [isFocus, setIsFocus] = React.useState(false);
  const isTiny = isFocus || props.value || props.type === "date";
  const minimumDate = props.isFuture ? dayjs().format("YYYY-MM-DD") : props.min;
  const showRandom = isFocus && !props.value && props.getRandom;

  return (
    <S.Container data-cy={props.datacy} readonly={props.readonly}>
      <S.Placeholder
        onClick={onClick}
        data-cy={props.name + "-text"}
        isTiny={isTiny}
        readonly={props.readonly}
        isSmall={props.isSmall}
      >
        {props.hint}
      </S.Placeholder>
      <S.Input {...getSubProps()} />
      <S.ErrorWrap>
        {props.error && (
          <T.CS weight={"bold"} colour={u.colours.errorRed}>
            {props.error}
          </T.CS>
        )}
      </S.ErrorWrap>
      {showRandom && <S.Random onMouseDown={props.getRandom} />}
    </S.Container>
  );

  function getSubProps() {
    return {
      ref: inputRef,
      onBlur: (e) => {
        setIsFocus(false);
        if (props.onBlur) props.onBlur(e);
      },
      onFocus: () => setIsFocus(true),
      value: props.value || "",
      onChange: props.onChange,
      type: props.type || "text",
      min: minimumDate,
      background: props.background,
      isSmall: props.isSmall,
      isContactPage: props.isContactPage,
      isPopUp: props.isPopUp,
      isInvalid: props.isInvalid,
      name: props.name,
      error: props.error,
      readonly: props.readonly,
      disabled: props.disabled,
      maxLength: props.maxLength,
      required: props.required,
      "data-cy": `${props.name}-input`,
    };
  }
}

const S = {};

S.Container = styled.div`
  position: relative;
  margin-bottom: 20px;
  ${(props) => props.readonly && `pointer-events: none;`}
`;

S.Placeholder = styled.p`
  color: ${u.colours.charcoal};
  font-size: 1.6rem;
  font-weight: 300;
  left: 16px;
  letter-spacing: 0.5px;
  position: absolute;
  top: 20px;
  transition: all 0.1s ease-out;
  :hover {
    cursor: pointer;
  }
  ${(p) =>
    p.isSmall &&
    `
    font-size: 14px;
    top: 10px;
    left: 20px;
  `}
  ${(p) =>
    p.isTiny &&
    `
    letter-spacing: 0px;
    font-size: 10px;
    left: 16px;
    top: 8px;
    ${
      p.isSmall &&
      `
      font-size: 8px;
      top: 3px;
      left: 20px;
    `
    }
  `}
  ${(props) => props.readonly && `color: grey;`}
`;

S.Input = styled.input`
  align-items: center;
  border: ${(p) =>
    p.isInvalid || p.error
      ? "1px solid " + u.colours.errorRed
      : p.required
        ? "2px solid " + u.colours.pillTeal
        : "1px solid " + u.colours.shellOverlay};
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px;
  color: ${u.colours.charcoal};
  display: flex;
  font-size: 1.5rem;
  height: ${(p) => (p.isSmall ? "37" : "59")}px;
  letter-spacing: 0.5px;
  margin-bottom: 5px;
  outline: none;
  padding-left: 16px;
  padding-top: 10px;
  width: 100%;
  z-index: 3;
  :hover {
    cursor: pointer;
  }
  :focus {
    border: 1px solid black;
  }
  ${(props) => props.showBorder && `border: 1px solid black;`}
  ${(props) => props.background && `background-color: ${props.background};`}
  ${(props) => props.readonly && `color: grey;`}
`;

S.ErrorWrap = styled.div`
  position: absolute;
  top: 2px;
  right: 5px;
`;

S.Random = styled.div`
  align-items: center;
  background: rgba(150, 150, 150, 0.5);
  border-radius: 13px;
  color: white;
  display: flex;
  font-size: 15px;
  font-weight: 700;
  height: 26px;
  justify-content: center;
  position: absolute;
  right: 10px;
  top: 12px;
  width: 26px;
  z-index: 10;
  :after {
    content: "?";
  }
  :hover {
    cursor: pointer;
    background: rgb(255, 152, 0);
  }
`;
